@let vm =
  {
    isSidebarShown: isSidebarShown$ | async,
    isDisclaimerCanvasShown: isDisclaimerCanvasShown$ | async,
    isNbaBarShown: isNbaBarShown$ | async,
    numberOfColumns: numberOfColumns$ | async,
    vehicle: vehicle$ | async,
    isSummaryPage: isSummaryPage$ | async
  };

@defer {
  <div class="cc-stage-with-sidebar">
    <ccwb-grid full-width>
      <ccwb-grid-row>
        <ccwb-grid-col
          [mq1]="defaultNumberOfColumns"
          [mq2]="defaultNumberOfColumns"
          [mq3]="defaultNumberOfColumns"
          [mq4]="vm.numberOfColumns.stageColumns[0]"
          [mq5]="vm.numberOfColumns.stageColumns[1]"
          [mq6]="vm.numberOfColumns.stageColumns[2]"
        >
          <div class="cc-stage-with-sidebar__content" [ngStyle]="vm.isSidebarShown ? stickyStageStyle : ''">
            <!-- STAGE -->
            <cc-main-stage
              [hasSelectionBoxLeftNextToIt]="hasSelectionBoxLeftNextToIt"
              [stickiness]="stickiness"
              backgroundTeleportSelector="#{{ appContainerId }}"
            />

            @if (vm.isDisclaimerCanvasShown) {
              <cc-disclaimer-canvas />
            }
            @if (!vm.isSidebarShown && vm.isSummaryPage) {
              <cc-summary-vehicle-data
                [vehicle]="vm.vehicle"
                [vehicleSummary]="vehicleSummary$"
                [sidebar]="vm.isSidebarShown"
              />
            }
          </div>
        </ccwb-grid-col>

        @if (vm.isSidebarShown) {
          <ccwb-grid-col
            [mq4]="vm.numberOfColumns.sidebarColumns[0]"
            [mq5]="vm.numberOfColumns.sidebarColumns[1]"
            [mq6]="vm.numberOfColumns.sidebarColumns[2]"
          >
            <cc-summary-sidebar class="cc-stage-with-sidebar__sidebar" />
          </ccwb-grid-col>
        }
      </ccwb-grid-row>
    </ccwb-grid>
  </div>
} @placeholder {
  <ccwb-skeleton class="stage-bone" />
  <div class="control-bar-bone">
    <ccwb-skeleton class="button-bone" />
    <ccwb-skeleton class="button-bone" />
    <ccwb-skeleton class="button-bone" />
  </div>
}
